import React, { createContext, useState, useContext, ReactNode } from "react";
import { Bill } from "../types";

interface BillContextType {
  selectedBill: Bill | null;
  setSelectedBill: (bill: Bill | null) => void;
}

const BillContext = createContext<BillContextType>({
  selectedBill: null,
  setSelectedBill: () => {},
});

export const BillProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [selectedBill, setSelectedBill] = useState<Bill | null>(null);

  return (
    <BillContext.Provider value={{ selectedBill, setSelectedBill }}>
      {children}
    </BillContext.Provider>
  );
};

export const useBill = () => useContext(BillContext);
